import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

import { compose } from '@agile-actors/client/commons/utils';
import { withCmsContent } from '@agile-actors/client/commons/components/cms';

import { Cards } from 'components';

import styles from './style';

type Props = {
  classes: Object,
  content: Object,
};

const CompanyBadges = ({ classes, content }: Props) => (
  <Cards content={content} styleOverides={{ image: classes.image }} />
);

export default compose(
  withCmsContent('companyBadges'),
  withStyles(styles),
)(CompanyBadges);
